import {
    useCallback,
    useMemo,
} from 'react'
import {
    Navigate,
    Outlet, useResolvedPath,
} from 'react-router-dom'
import Box from '@mui/material/Box'

import {
    SidebarTab,
} from 'app/shared-components/SkyNetDomain'

import SkyNetTabs from 'app/PoC/DataGridDemoPages/components/SkyNetTabs'
import useDetailedViewOutlet
    from 'app/PoC/DataGridDemoPages/components/SkyNetMasterDataGrid/hooks/useDetailedViewOutlet'
import {
    SkyNetDomainFormOutletContext,
} from '../../SkyNetDomain.types'
import CloseButton from '../CloseButton'
import useStyles from './SkyNetDomainFormTabs.styles'

// TODO-JM: selected row in main table -> IP-21537

/* Component for Tabs for Detailed View Forms  */
function SkyNetDomainFormTabs({
    forms,
}: Readonly<{
    forms: SidebarTab[],
}>) {
    const {
        activeTabName: tableTabName,
        locationPathname,
        tablePath,
        id,
        navigate,
    } = useDetailedViewOutlet()
    const {
        classes,
    } = useStyles()
    const {
        pathname: backPath,
    } = useResolvedPath('..')

    const tabs = useMemo(() => {
        // TODO-JM: filter tabs by permissions, config or request (postponed - no use-case for now)
        return forms.map(({
            label, url,
        }) => {
            return {
                name: label,
                url,
            }
        })
    }, [forms])

    const findTabIndex = useCallback((tabName) => {
        return tabs.findIndex((tab) => {
            return tab.url === tabName
        })
    }, [tabs])

    const activeTabName = useMemo(() => {
        const regex = new RegExp(`${tablePath}/${tableTabName}/${id}/([^/]+)`)
        const match = locationPathname.match(regex)
        const tabName = match ? tabs[findTabIndex(match[1])]?.url : null

        return tabName
    }, [
        id,
        locationPathname,
        tablePath,
        tableTabName,
        tabs,
        findTabIndex,
    ])

    const getNewTabUrl = useCallback((tabIndex: number) => {
        return `${tablePath}/${tableTabName}/${id}/${tabs[tabIndex].url}`
    }, [
        id,
        tablePath,
        tableTabName,
        tabs,
    ])

    const onActiveTabChange = (newValue: number) => {
        navigate(getNewTabUrl(newValue))
    }

    const activeTab = useMemo(() => {
        const tabIndex = findTabIndex(activeTabName)

        return tabIndex > -1 ? tabIndex : 0
    }, [
        findTabIndex,
        activeTabName,
    ])

    const RedirectElement = useMemo(() => {
        if (activeTabName) return null
        return (
            <Navigate
                to={getNewTabUrl(0)}
                replace
            />
        )
    }, [
        activeTabName,
        getNewTabUrl,
    ])

    const onClose = () => {
        navigate(backPath)
    }

    /* passing custom props to components rendered in the Outlet */
    const outletContext: SkyNetDomainFormOutletContext = useMemo(() => {
        return {
            backPath,
        }
    }, [backPath])

    return (
        <Box sx={{
            flex: 1,
        }}
        >
            <div className={classes.root}>
                <SkyNetTabs
                    value={activeTab}
                    tabs={tabs}
                    onChange={onActiveTabChange}
                />
                <CloseButton onClose={onClose} />
            </div>
            <Outlet context={outletContext} />
            {RedirectElement}
        </Box>
    )
}

export default SkyNetDomainFormTabs
